import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import ActionButton from "./ActionButton";


const DeleteUserModal = ({ open, onClose, onConfirm, user }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete User</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete{" "}
          <strong>{user?.firstName} {user?.lastName}</strong>? This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <ActionButton onClick={onClose} tone="ghost">
          Cancel
        </ActionButton>
        
        <ActionButton onClick={onConfirm} tone="danger">
          Delete
        </ActionButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteUserModal;
